import {
  POPUP_TEAM_BASE,
  AWARENESS_PIPELINE_SEGMENT,
  isMobileTeamViewport,
  resolveAwarenessPipelineAppUrl,
} from "./teamNavigation";
import { appNavigate } from "./appNavigateBridge";
import { openWindowWithTabAuth } from "./tabAuthStorage";

/**
 * Abre os níveis de consciência em janela popup (/popup-equipe/pipeline).
 * No mobile, navega para /equipe/pipeline dentro do app principal.
 */
export function openAwarenessPipelinePopupWindow() {
  if (isMobileTeamViewport()) {
    appNavigate(resolveAwarenessPipelineAppUrl());
    return null;
  }

  const url = `${POPUP_TEAM_BASE}${AWARENESS_PIPELINE_SEGMENT}`.replace(/\/+$/, "");
  const width = window.screen.availWidth || window.screen.width;
  const height = window.screen.availHeight || window.screen.height;

  return openWindowWithTabAuth(
    url,
    "AwarenessPipelinePopup",
    `width=${width},height=${height},top=0,left=0,scrollbars=no,toolbar=no,location=no,status=no,menubar=no`
  );
}
